/* @flow */
import type { MediaAggregationKey } from './MediaAggregationKey';
import type { PaginationParams } from './PaginationParams';
import type { SortingParams } from './SortingParams';
import type { MediaSortingField } from './MediaSortingField';

export type MediaSearchParams = {
  categoryIds: number[],
  filters?: {
    [MediaAggregationKey]: any[],
  },
  filtersMeta?: {
    [MediaAggregationKey]: {
      filter?: string | null,
      pagination?: number,
    },
  },
  excludeProductionMusic?: boolean,
  news?: boolean,
  enteId?: number,
  featuredId?: number,
  pagination?: PaginationParams,
  sorting?: SortingParams<MediaSortingField>,
};

export const mediaSearchParamsProps = [
  'categoryIds',
  'filters',
  'filtersMeta',
  'excludeProductionMusic',
  'news',
  'enteId',
  'featuredId',
  'pagination',
  'sorting',
];
